import { Link } from "@tanstack/react-router";
import { siteConfig, categorySlug } from "@/config";

const legalLinks = [
  { label: "About", to: "/about-us" as const },
  { label: "Contact", to: "/contact-us" as const },
  { label: "Editorial Policy", to: "/editorial-policy" as const },
  { label: "Affiliate Disclosure", to: "/affiliate-disclosure" as const },
  { label: "Privacy Policy", to: "/privacy-policy" as const },
  { label: "Terms & Conditions", to: "/terms-condition" as const },
];

export function Footer() {
  const year = new Date().getUTCFullYear();
  return (
    <footer className="mt-16 border-t border-border bg-card">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 py-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span
              aria-hidden="true"
              className="grid h-8 w-8 place-items-center rounded-md bg-primary text-primary-foreground font-bold"
            >
              G
            </span>
            <span className="text-lg font-bold tracking-tight">
              {siteConfig.siteName}
            </span>
          </div>
          <p className="mt-3 max-w-sm text-sm text-muted-foreground">
            {siteConfig.description}
          </p>
          <p className="mt-4 max-w-sm text-xs text-muted-foreground">
            {siteConfig.siteName} is reader-supported. When you buy through
            links on our site, we may earn an affiliate commission at no cost
            to you. See our{" "}
            <Link to="/affiliate-disclosure" className="underline">
              affiliate disclosure
            </Link>
            .
          </p>
        </div>
        <nav aria-label="Topics" className="text-sm">
          <h4 className="mb-3 font-semibold">Topics</h4>
          <ul className="space-y-2">
            {siteConfig.categories.map((c) => (
              <li key={c}>
                <Link
                  to="/category/$category"
                  params={{ category: categorySlug(c) }}
                  className="text-muted-foreground hover:text-foreground"
                >
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <nav aria-label="Site" className="text-sm">
          <h4 className="mb-3 font-semibold">Site</h4>
          <ul className="space-y-2">
            {legalLinks.map((n) => (
              <li key={n.to}>
                <Link
                  to={n.to}
                  className="text-muted-foreground hover:text-foreground"
                >
                  {n.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                className="text-muted-foreground hover:text-foreground"
                href={`mailto:${siteConfig.contactEmail}`}
              >
                {siteConfig.contactEmail}
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
        © {year} {siteConfig.siteName}. All rights reserved.
      </div>
    </footer>
  );
}

